const api = {
    login: "/authentication_token",
    employee: "/api/employee/me",
    crypto_transactions: "/api/cryptobanks/transactions",
    get_total_for_user_balances: "/api/currencies/get-total-for-user-balances",
    currencies: "/api/currencies",
    cryptobanks: "/api/cryptobanks",
    employees: "/api/employees",
    roles: "/api/roles",
    ips: "/api/ips",
    cryptobank_excel: "/api/cryptobanks/excel",
    employees_excel: "/api/employees/excel",
    transactions_calculate:"transactions/calculate",
    institutions: "/api/institutions",
    permission: "crmv1/authority/roles/employee-permissions",
};

export default api;
